import React from 'react';
import { Link } from '@latitude/link';
import { ConfettiFramedContainer } from '@latitude/confetti-framed-container';
import { Row, Cell, Table } from '../TableNew/TableNew';
import { parseContent } from '../../utils/helpers';
import { Box } from '../Box/Box';
import { PADDING } from '../../utils/constants';
import './_personal-loan-details.scss';

/**
 * Tealium event_location value tracking
 */

const heading = 'Fees & charges';

const PersonalLoanDetails = props => (
  <ConfettiFramedContainer heading={heading} id="details">
    <Box padding={PADDING.P24}>
      <Table>
        <tbody>
          {props.data.map((rowData, rowIndex) =>
            rowData.map((cellData, cellIndex) => (
              /**
               * mergeDown logic removes the line between rows if:
               * -there are multiple rows within the same block, so each row except the last should not have border OR
               * -it is the very last item of the entire array which also does not have a border
               *  */

              <Row
                key={`loanDetails-${rowIndex}-${cellIndex}`}
                mergeDown={
                  (rowData.length > 1 && cellIndex !== rowData.length - 1) ||
                  (rowIndex === props.data.length - 1 &&
                    cellIndex === rowData.length - 1 &&
                    !props.determineRateLink)
                }
              >
                {cellData.map((singleCell, singleCellIndex) => {
                  if (singleCell) {
                    return (
                      <Cell
                        key={`loanDetails-${rowIndex}-${cellIndex}-${singleCellIndex}`}
                      >
                        {parseContent(singleCell)}
                      </Cell>
                    );
                  }
                  return (
                    <Cell
                      key={`loanDetails-${rowIndex}-${cellIndex}-${singleCellIndex}`}
                    />
                  );
                })}
              </Row>
            ))
          )}
          {props.determineRateLink && (
            <Row mergeDown>
              <Cell colSpan="2">
                <div className="loan-type">
                  <svg
                    height="16px"
                    width="16px"
                    className="exclamation"
                    role="img"
                  >
                    <use
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      xlinkHref="/assets/icons/icons-sprite.svg#info-block"
                    />
                  </svg>
                  <Link
                    className="loan-type-link"
                    data-trackid="rates-determine-rate"
                    href="/how-interest-rates-are-determined/"
                    trackEventData={{
                      location: heading
                    }}
                  >
                    How is my interest rate determined?
                  </Link>
                </div>
              </Cell>
            </Row>
          )}
        </tbody>
      </Table>
    </Box>
  </ConfettiFramedContainer>
);

export default PersonalLoanDetails;
